import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';

@Component({
    selector: 'customer-splits-details.',
    templateUrl: 'customer-splits-details.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ],
})

export class CustomerSplitDetailsComponent {
    bookingRequests: any[];
    Error: string;
    name: string;
    displayedColumnsSplits: string[] = ['categoryType', 'name', 'quantity', 'percentage', 'amount']
    @Output() sendResponseEventEmitter = new EventEmitter<any>();
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.bookingRequests = data.bookingRequests;
        }
    }
}